import { useId } from 'react';
import SearchInput from 'src/components/form/search/filters-form/search-input';
import Filters from 'src/components/form/filters/filters';
import { searchInputValidationSchema } from 'src/components/form/search/filters-form/helper';
import css from './form.module.scss';
import { SearchFormProps, WorkFilters } from 'src/types';
import { ReactComponent as Tune } from 'src/assets/tune.svg';

export default function SearchForm({
  onSubmit,
  initialValues,
  changePopupState
}: Readonly<SearchFormProps<Partial<WorkFilters>> & { changePopupState?: () => void }>) {
  const inputId = useId();

  return (
    <Filters
      initialFilters={initialValues}
      onSearch={onSubmit}
      validationSchema={searchInputValidationSchema('search')}
      fieldsToSubmitOnChange={['search']}
      render={({ errors, _, registerAndClearOnChange }) => (
        <div className={css.workInputGroup}>
          <SearchInput
            id={inputId}
            name='search'
            placeholder='Шукати вакансію'
            inputProps={registerAndClearOnChange('search')}
            error={errors?.search?.message}
          />
          <button className={css.filtersButton} onClick={changePopupState}>
            <Tune />
          </button>
        </div>
      )}
    />
  );
}
